module.exports = __webpack_public_path__ + "media/images/smiling-baby-primary-blue-7be4c22591fac6bf62e59f6197487598.png";